import { render, staticRenderFns } from "./CobraQuoteSetup.vue?vue&type=template&id=23303c71&scoped=true"
import script from "./CobraQuoteSetup.vue?vue&type=script&lang=js"
export * from "./CobraQuoteSetup.vue?vue&type=script&lang=js"
import style0 from "./CobraQuoteSetup.vue?vue&type=style&index=0&id=23303c71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23303c71",
  null
  
)

export default component.exports